import React from 'react';
import { useFilterStore } from '../store/filterStore';
import { useFilterOptions } from '../hooks/useFilterOptions';
import { SlidersHorizontalIcon, XIcon } from 'lucide-react';
function FilterSelect({
  label,
  column,
  value,
  onChange
}: {
  label: string;
  column: string;
  value: string;
  onChange: (val: string) => void;
}) {
  const options = useFilterOptions(column);
  const isActive = !!value;
  return <div className="flex flex-col gap-1.5 min-w-[130px] flex-1" data-id="element-84" data-mp="1yndb5wzf7emq">
      <label className="text-[10px] font-semibold text-slate-500 uppercase tracking-[0.12em] flex items-center gap-1.5" data-id="element-85" data-mp="1tnh5zuezlh5l">
        {label}
        {isActive && <span className="w-1 h-1 rounded-full bg-cyan-400 shadow-[0_0_6px_rgba(34,211,238,0.8)]" data-id="element-86" data-mp="28lt4m6lx6zze" />}
      </label>
      <select value={value} onChange={e => onChange(e.target.value)} className={`
          filter-select text-sm rounded-lg block w-full px-3 py-2 outline-none
          transition-all duration-200 cursor-pointer
          ${isActive ? 'border border-cyan-400/40 text-cyan-200 bg-cyan-500/5 shadow-[0_0_0_3px_rgba(34,211,238,0.06)]' : 'border border-slate-700/70 text-slate-300 hover:border-slate-600 hover:bg-slate-900/90'}
        `} data-id="element-87" data-mp="23nrhnaldigin">
        <option value="" data-id="element-88" data-mp="1rtqusqlx5sv6">All</option>
        {options.map(opt => <option key={opt} value={opt} className="bg-slate-900" data-id="element-89" data-mp="1vtj63b2p6d48">
            {opt}
          </option>)}
      </select>
    </div>;
}
export function GlobalFilters() {
  const filters = useFilterStore();
  const activeCount = [filters.TREG, filters.Regional_Tsel, filters.Tipe_Site, filters.Mitra, filters.Frekuensi, filters.Status_Redeploy, filters.Status_Material].filter(v => typeof v === 'string' && v !== '').length;
  return <div className="glass-panel p-4 md:p-5 rounded-2xl flex flex-col lg:flex-row gap-4 items-stretch lg:items-end relative" data-id="element-90" data-mp="ge2ay83yp9yl">
      <div className="flex items-center gap-2 lg:mr-2 lg:pb-2 flex-shrink-0" data-id="element-91" data-mp="kecdtbwgjk98">
        <div className="p-1.5 rounded-lg bg-cyan-500/10 border border-cyan-400/30 text-cyan-300" data-id="element-92" data-mp="1nprscrncp0me">
          <SlidersHorizontalIcon size={15} data-id="element-93" data-mp="1irqdyk0vdph9" />
        </div>
        <div className="flex flex-col leading-tight" data-id="element-94" data-mp="1ip43ocmlgvvc">
          <span className="text-xs font-semibold text-slate-200 tracking-wide" data-id="element-95" data-mp="1xf30aayi3z8p">
            Filters
          </span>
          <span className="text-[10px] text-slate-500 font-mono" data-id="element-96" data-mp="1sicohztqbpt3">
            {activeCount > 0 ? `${activeCount} active` : 'none active'}
          </span>
        </div>
      </div>

      <div className="flex flex-wrap lg:flex-nowrap gap-3 flex-1 w-full" data-id="element-97" data-mp="zt5kilbia80g">
        <FilterSelect label="TREG" column="TREG" value={filters.TREG} onChange={v => filters.setFilter('TREG', v)} data-id="element-98" data-mp="1drvn2gh3gzw7" />
        <FilterSelect label="Regional" column="Regional_Tsel" value={filters.Regional_Tsel} onChange={v => filters.setFilter('Regional_Tsel', v)} data-id="element-99" data-mp="19smrr76eotyj" />
        <FilterSelect label="Site Type" column="Tipe_Site" value={filters.Tipe_Site} onChange={v => filters.setFilter('Tipe_Site', v)} data-id="element-100" data-mp="2l7rx6ixx96lu" />
        <FilterSelect label="Mitra" column="Mitra" value={filters.Mitra} onChange={v => filters.setFilter('Mitra', v)} data-id="element-101" data-mp="2xpm7kdti7t0e" />
        <FilterSelect label="Frequency" column="Frekuensi" value={filters.Frekuensi} onChange={v => filters.setFilter('Frekuensi', v)} data-id="element-102" data-mp="2nr6g29qkehqd" />
        <FilterSelect label="Redeploy" column="Status_Redeploy" value={filters.Status_Redeploy} onChange={v => filters.setFilter('Status_Redeploy', v)} data-id="element-103" data-mp="3gf2994gxdrie" />
        <FilterSelect label="Material" column="Status_Material" value={filters.Status_Material} onChange={v => filters.setFilter('Status_Material', v)} data-id="element-104" data-mp="36o7l1uk4chub" />
      </div>

      {activeCount > 0 && <button onClick={filters.resetFilters} className="flex items-center gap-2 px-3.5 py-2 bg-slate-800/80 hover:bg-red-500/15 text-slate-300 hover:text-red-300 text-xs font-semibold rounded-lg transition-all border border-slate-700/80 hover:border-red-400/40 flex-shrink-0" data-id="element-105" data-mp="31z61hqlaih7">
          <XIcon size={14} data-id="element-106" data-mp="21km40c0kjpjo" />
          <span data-id="element-107" data-mp="1wk7u0ofeq5j0">Reset</span>
        </button>}
    </div>;
}